<template>
  <div id="index" ref="appRef">
    <audio ref="audio" :src="music_path" >
    </audio>

    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <div class="d-flex jc-center" style="margin-top:70px">
          <dv-decoration-10 class="dv-dec-10" />
          <div class="d-flex jc-center">
            <dv-decoration-8 class="dv-dec-8" :color="['#568aea', '#000000']" />
            <div class="title">
              <span class="title-text">订单排号系统</span>
              <!-- <button @click="playStart" v-if="!is_play">开始播放语音</button>
              <button @click="playStop" v-if="is_play">停止播放语音</button> -->
              <dv-decoration-6
                class="dv-dec-6"
                :reverse="true"
                :color="['#50e3c2', '#67a1e5']"
              />
            </div>
            <dv-decoration-8
              class="dv-dec-8"
              :reverse="true"
              :color="['#568aea', '#000000']"
            />
          </div>
          <dv-decoration-10 class="dv-dec-10-s" />
        </div>
        <!-- 第二行 -->
        <div class="d-flex jc-between px-2">
          <div class="d-flex aside-width"></div>
          <div class="d-flex aside-width">
            <div class="react-right mr-4 react-l-s">
              <span class="react-after"></span>
              <span class="text"
                >{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span
              >
            </div>
          </div>
        </div>
        <div class="body-box">
          <!-- 第三行数据 -->
          <div class="content-box">
            <div style="width:33%;display:inline-block;">
                <dv-decoration-9 :dur="order_data.order_num_over.dur" style="width:300px;height:300px;text-align:center;font-size:30px;margin: 0 auto">
                  待处理<br/><br/>
                  {{order_data.order_num_over.num}}单
                  </dv-decoration-9>
            </div>
            <div style="width:33%;display:inline-block;">
            <dv-decoration-9 :dur="order_data.order_num_no.dur" style="width:300px;height:300px;text-align:center;font-size:30px;margin: 0 auto">
              已处理<br/><br/>
                    {{order_data.order_num_no.num}}单
              </dv-decoration-9>
            </div>
            <div style="width:33%;display:inline-block;">
            <dv-decoration-9  :dur="order_data.order_num_yl.dur" style="width:300px;height:300px;text-align:center;font-size:30px;margin: 0 auto">
              剩余运力<br/><br/>{{order_data.order_num_yl.num}}单
              </dv-decoration-9>
            </div>
          </div>
        </div>
        <div>
          <dv-scroll-board :config="config" style="width:100%;height:500px;margin-top:20px;padding:20px" />
        </div>
      </div>
    </div>
  </div>
</template>




<script>
import drawMixin from "../utils/drawMixin";
import { formatTime,getUrl } from "../utils/index.js";
import Speech from "speak-tts";
export default {
  mixins: [drawMixin],
  data() {
    return {
      order_data: {},
      music_path: "https://imgs.xinfucai.cn/Static/audio/xindingdan.mp3",
      config: {
        headerHeight: 100,
        header: [
          // "<span style='font-size:30px;'>序号</span>",
          "<span style='font-size:30px;'>时间段</span>",
          "<span style='font-size:30px;'>已排订单数量</span>",
          "<span style='font-size:30px;'>剩余可安排数量</span>",
          "<span style='font-size:30px;'>运力</span>",
        ],
        data: [],
        // index: true,
        // columnWidth: [150],
        align: ["center","center","center","center"],
        rowNum: 8,
        carousel: "single",
        waitTime: 4000,
      },
      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      websock: null,
      cdata: {},
      is_play: false,
    };
  },
  components: {},
  mounted() {
    this.timeFn();
    // this.cancelLoading();
  },
  created() {
    this.initWebSocket();
  },
  destroyed() {
    this.websock.close(); //离开路由之后断开websocket连接
  },
  beforeDestroy() {
    clearInterval(this.timing);
  },
  methods: {
    playStart() {
      this.is_play = true;
      this.$refs.audio.src = this.music_path;
      this.$refs["audio"].play();
    },
    playStop() {
      this.is_play = false;
    },
    //语音播报
    reloadYP() {
      this.$refs.audio.src = this.music_path;
      if (this.is_play) {
        //   this.$refs['audio'].pause();
        //   this.is_play = false
        //   this.buttonText = 'stopped'
        // } else {
        this.$refs["audio"].play();
        // this.is_play = true
        // this.buttonText = 'starting'
      }
    },

    speechInit() {
      this.speech = new Speech();
      this.speech.setLanguage("zh-CN");
      this.speech.init().then(() => {
        console.log("语音播报初始化完成...");
      });
    },

    //  语音播报
    speak(text) {
      console.log(text);
      console.log(this.speech);
      this.speech.speak({ text: text }).then(() => {
        console.log("播报完成...");
      });
    },

    //语音播报结束

    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), "HH: mm: ss");
        this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },

    initWebSocket() {
      //初始化weosocket
      let url=getUrl();
      const wsuri = url.url;
      // const wsuri = "ws://127.0.0.1:9502";
      // const wsuri = "wss://ws.hzsp668.com";
      // const wsuri = "wss://ws.hfx.xinfucai.cn";
      // const wsuri = "wss://ws.kaida668.com";
      // const wsuri = "wss://ws.jiaqifucai.cn";
      // const wsuri = "ws://ws.chenxinjc.com";
      // const wsuri = "wss://ws.qlsp168.cn";
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      let url=getUrl();
      let region_id = url.region_id+"_dd";
      // let region_id = '52_kefu';
      // let region_id = '163_kefu';
      // let region_id = '138_kefu';
      // let region_id = '343_kefu';
      // let region_id = '140_kefu';
      // let region_id = '197_kefu';
      let original_data = {
        class: "Login",
        action: "loginDp",
        content: {
          region_id,
        },
      };
      this.websocketsend(JSON.stringify(original_data));
      this.heartCheckReset()
      this.heartCheckStart()
      //请求数据
      // let get_data = {
      //   class: "Login",
      //   action: "loginDp",
      //   content: {
      //     region_id,
      //   },
      // };
      //  this.websocketsend(JSON.stringify(get_data));
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      console.log('接收消息')
      const redata = JSON.parse(e.data);
      if(redata.type != 'ping'){
        console.log(redata);
        let config = this.config;
        this.order_data = redata.order_data;
        this.cancelLoading();
        config= {
          headerHeight: 100,
          header: [
            // "<span style='font-size:30px;'>序号</span>",
            "<span style='font-size:30px;'>时间段</span>",
            "<span style='font-size:30px;'>已排订单数量</span>",
            "<span style='font-size:30px;'>剩余可安排数量</span>",
            "<span style='font-size:30px;'>运力</span>",
          ],
          data: redata.list,
          align: ["center","center","center","center"],
          rowNum: 5,
          carousel: "single",
          // columnWidth: [100,200],
          waitTime: 4000,
        }
        this.config = config;

      }
      this.heartCheckReset()
      this.heartCheckStart()
    },
    websocketsend(Data) {
      //数据发送
      console.log('推送消息')
      this.websock.send(Data);
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
      this.initWebSocket();
    },
    heartCheckReset() {
      clearTimeout(this.timeoutObj);
      clearTimeout(this.serverTimeoutObj);
    },
    // 开启定时器
    heartCheckStart() {
      var self = this;
      this.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        //onmessage拿到返回的心跳就说明连接正常
        // self.ws.send("ping");
        var ping='ping';
        let url=getUrl();
        let region_id = url.region_id+"_dd";
        let send_data = {
          class: "Login",
          action: "loginDpHeart",
          content: {
            ping,
            region_id
          },
        };
        self.websocketsend(JSON.stringify(send_data))
        // console.log("ping!")
        // self.serverTimeoutObj = setTimeout(function () { //如果超过一定时间还没重置，说明后端主动断开了
        //   self.ws.close();
        // },30000 )
      }, 30000)

    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/index.scss";
</style>
